import useEngagementStore from "modules/dashboards/engagement/store";
import React, { useEffect, useState } from "react";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import useAllTicketStore from "./all_tickets/store";
import secureLocalStorage from "react-secure-storage";

function AssignTo({ selectedAssign, setSelectedAssign }) {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const {teamData, fetchTeamData}=useEngagementStore();
  const {userData, fetchUserData} = useAllTicketStore();
  const [optionList, setOptionList]=useState()

useEffect(()=>{
  fetchUserData();
  fetchTeamData();
},[])


useEffect(() => {
  if (userData) {
    const example = userData?.map(item => ({
      label: item.user.first_name,
      value: item.user.id,
    }));
    setOptionList(example);
  }
  if (teamData && teamData?.length > 0) {
    const teamOption = teamData?.[0]?.userGroup
      ?.map(item => ({
        label: item.user.first_name,
        value: item.user.id,
      }))
      .concat({
        label: secureLocalStorage.getItem("first_name"),
        value: teamData[0].user_id,
      });
    setOptionList(teamOption);
  }
}, [userData, teamData]);


  function handleSelect(data) {
    setSelectedAssign(data);
  }
  return (
    <>
      <h5 className="mt-3">Assign To</h5>
      <span
        className="d-inline-block"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please selecet account(s)"
      >
        <ReactSelect
          options={optionList}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option,
          }}
          onChange={handleSelect}
          allowSelectAll={true}
          value={selectedAssign}
        />
      </span>
    </>
  );
}

export default AssignTo;
